<script lang="ts">
	import { browser } from '$app/environment';
	import { IsInView } from '@actions';
	import type { Layout } from './OvalLayout';
	import { OvalsInCanvas } from './OvalsInCanvas';
	import { onDestroy } from 'svelte';

	let {
		layout
	}: {
		layout?: Layout;
		start?: boolean;
		mask?: boolean;
		fade?: boolean;
	} = $props();

	let width: number = $state(0);
	let height: number = $state(0);
	let pixelRatio = $state(browser ? Math.min(window.devicePixelRatio, 2) : 1);
	let isInView = $state(false);

	const ovals = new OvalsInCanvas(layout);

	$effect(() => {
		if (isInView) {
			ovals.start();
		} else {
			ovals.stop();
		}
	});

	onDestroy(() => {
		ovals.stop();
	});

	$effect(() => {
		ovals.goto(layout);
	});
</script>

<canvas
	bind:this={ovals.target}
	bind:offsetWidth={width}
	bind:offsetHeight={height}
	width={width * pixelRatio}
	height={height * pixelRatio}
	use:IsInView={(isIntersecting) => (isInView = isIntersecting)}
></canvas>

<style lang="scss">
	canvas {
		position: absolute;
		z-index: 2;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
</style>
